import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-razorpay-response',
    imports: [CommonModule, RouterModule, MatCardModule, MatButtonModule, MatIconModule],
    templateUrl: './razorpay-response.html',
    styleUrl: './razorpay-response.scss'
})
export class RazorpayResponse implements OnInit {
  status: string = '';
  bookingid: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // Get route parameters
    this.route.params.subscribe(params => {
      this.status = params['s'] || 'success';
      this.bookingid = params['d'] || 'N/A';
    });
  }

  close(): void {
    this.router.navigate(['/home']);
  }
}
